export default function () {
  const loaderRef = document.querySelector('.spinner');
  loaderRef.classList.add('opacity');
  loaderRef.innerHTML = '';
}
